export function keysof<K extends string>(record: Partial<Record<K, any>>): Array<K> {
    return Object.keys(record) as Array<K>
}
